<div class="worker-agreements-list container">
  <div class="content">
    <div class="content-card filters">
      <div class="top">
        <div class="top__left">
          @if (isSelectedActionButtonVisible()) {
            <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">
              {{ 'WL-Actions' | translate }}
            </button>
          }
          <mat-menu #menu="matMenu" class="multiple-agreement-actions-btn">
            <button
              mat-menu-item
              (click)="generateMultipleAgreements()"
              [disabled]="!isGenerationOnMultipleAgreementsEnabled()"
              [visibleWithPermissions]="['ManageAllExternalWorkersList', 'ManageMyExternalWorkersList']"
              >
              <span [matTooltip]="'GenerateMultipleAgreementsTooltip' | translate" matTooltipClass="worker-agreements-list-tooltip">{{
                'GenerateMultipleAgreements' | translate
              }}</span>
            </button>
            <button
              mat-menu-item
              (click)="extendMultipleAgreements()"
              [disabled]="!isExtensionOnMultipleAgreementsEnabled()"
              [visibleWithPermissions]="['ManageAllExternalWorkersList', 'ManageMyExternalWorkersList']"
              >
              <span [matTooltip]="'ExtendMultipleAgreementsTooltip' | translate" matTooltipClass="worker-agreements-list-tooltip">{{
                'ExtendMultipleAgreements' | translate
              }}</span>
            </button>
            <button
              mat-menu-item
              (click)="sendMultipleAgreementsToApproval()"
              [disabled]="!isSendingMultipleAgreementsToApprovalEnabled()"
              [visibleWithPermissions]="['SendMultipleWorkerAgreementsToApproval']"
              >
              <span [matTooltip]="'SendToApprovalMultipleAgreementsTooltip' | translate" matTooltipClass="worker-agreements-list-tooltip">{{
                'SendToApprovalMultipleAgreements' | translate
              }}</span>
            </button>
            <button
              mat-menu-item
              [visibleWithPermissions]="['ManageAllExternalWorkersList', 'ManageMyExternalWorkersList']"
              [disabled]="!isSendAgreementExtensionConsentButtonEnabled()"
              (click)="sendAgreementExtensionConsent()"
              >
              <span matTooltip="{{ 'SendAgreementExtensionConsentTooltip' | translate }}" matTooltipClass="worker-agreements-list-tooltip">{{
                'SendAgreementExtensionConsent' | translate
              }}</span>
            </button>
            <button
              mat-menu-item
              [visibleWithPermissions]="['CreateEmploymentConditionsConfirmation']"
              (click)="createEmploymentConditionsConfirmations()"
              [matTooltip]="'CreateEmploymentConditionsConfirmationsTooltip' | translate"
              [disabled]="!isAnyWorkeAgreemetnSelected()"
              matTooltipClass="worker-agreements-list-tooltip"
              >
              <span>{{ 'CreateEmploymentConditionsConfirmations' | translate }}</span>
            </button>
          </mat-menu>
        </div>
        <div class="top__right">
          <div class="filter-button-container">
            <button (click)="resetFilters()" class="top__button top__button-clear">
              <mat-icon>close</mat-icon>
              {{ 'Reset' | translate }}
            </button>
            <button
              (click)="toggleFiltersPanel()"
              class="top__button top__button-filter"
              [matBadge]="filters.length"
              matBadgeSize="small"
              [matBadgeHidden]="!filters.length"
              >
              <mat-icon>filter_alt</mat-icon>
              {{ 'Filter' | translate }}
            </button>
          </div>
        </div>
      </div>
      @if (areFiltersExpanded) {
        <app-list-filter></app-list-filter>
      }
    </div>

    <div class="content-card" [ngClass]="{ 'filters-opened': areFiltersExpanded }">
      <div #tableContainer class="wrapper custom-table">
        <cdk-virtual-scroll-viewport gridTableVirtualScroll (scrolledIndexChange)="nextBatch($event)">
          <mat-table
            class="table"
            matSort
            matSortActive="CreatedOn"
            matSortDirection="desc"
            matSortDisableClear
            [dataSource]="dataSource"
            (matSortChange)="onSortChange()"
            [trackBy]="trackBy"
            >
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select" sticky>
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  appearance="outline"
                  (change)="onSelectAllChxChange()"
                  [checked]="dataSource.selection.hasValue() && isAllSelected()"
                  [indeterminate]="dataSource.selection.hasValue() && !isAllSelected()"
                  [matTooltip]="'SelectAll' | translate"
                  matTooltipPosition="above"
                  matTooltipClass="worker-agreements-list-tooltip"
                  >
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="onRowChxChange($event, row)"
                  [checked]="dataSource.selection.isSelected(row)"
                  >
                </mat-checkbox>
              </mat-cell>
            </ng-container>
            <!-- WorkerId Column -->
            <ng-container matColumnDef="WorkerId" [sticky]="screenService.isAboveMd$ | async">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'WL-WorkerId' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.WorkerId }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="LastName" [sticky]="screenService.isAboveMd$ | async">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'WL-Name' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><a
                class="user"
                [routerLink]="['/profile/' + element.WorkerId]"
                matTooltip="{{ 'WL-ShowWokerProfile' | translate }}"
                matTooltipPosition="above"
                matTooltipClass="worker-agreements-list-tooltip"
                >{{ element.LastName }} {{ element.FirstName }}</a
                >
                @if (element.LegalizationStatusId) {
                  <div
                    [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']"
                    >
                    <app-legalization-status-info [element]="element" [showTooltip]="true"></app-legalization-status-info>
                  </div>
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Company">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="hidden-sort"
                [style.minWidth.px]="getColumnWidth('Company')"
                [style.maxWidth.px]="getColumnWidth('Company')"
                >
                {{ 'Company' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [style.minWidth.px]="getColumnWidth('Company')" [style.maxWidth.px]="getColumnWidth('Company')"
                ><span [matTooltip]="element.Company" matTooltipClass="worker-agreements-list-tooltip">{{ element.Company }}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="EmployerName">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="hidden-sort"
                [style.minWidth.px]="getColumnWidth('EmployerName')"
                [style.maxWidth.px]="getColumnWidth('EmployerName')"
                >
                {{ 'WL-EmployerName' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                [style.minWidth.px]="getColumnWidth('EmployerName')"
                [style.maxWidth.px]="getColumnWidth('EmployerName')"
                ><span [matTooltip]="element.EmployerName" matTooltipClass="worker-agreements-list-tooltip">{{ element.EmployerName }}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="EmployerObject">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="hidden-sort"
                [style.minWidth.px]="getColumnWidth('EmployerObject')"
                [style.maxWidth.px]="getColumnWidth('EmployerObject')"
                >
                {{ 'EmployerObject' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell
                *matCellDef="let element"
                [style.minWidth.px]="getColumnWidth('EmployerObject')"
                [style.maxWidth.px]="getColumnWidth('EmployerObject')"
                >
                <span [matTooltip]="element.EmployerObject" matTooltipClass="worker-agreements-list-tooltip">{{ element.EmployerObject }}</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="EmploymentType">
              <mat-header-cell *matHeaderCellDef mat-sort-header="EmploymentTypeId" class="hidden-sort">
                {{ 'EmploymentType' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><span [matTooltip]="element.EmploymentType" matTooltipClass="worker-agreements-list-tooltip">{{
                element.EmploymentType
              }}</span></mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="AgreementType">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'WL-AgreementType' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><span [matTooltip]="element.AgreementType" matTooltipClass="worker-agreements-list-tooltip">{{
                element.AgreementType
              }}</span></mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="JobTitle">
              <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="hidden-sort"
                [style.minWidth.px]="getColumnWidth('JobTitle')"
                [style.maxWidth.px]="getColumnWidth('JobTitle')"
                >
                {{ 'JobTitleWithActivityGroup' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [style.minWidth.px]="getColumnWidth('JobTitle')" [style.maxWidth.px]="getColumnWidth('JobTitle')"
                ><span [matTooltip]="element.JobTitle" matTooltipClass="worker-agreements-list-tooltip">{{ element.JobTitle }}</span></mat-cell
                >
              </ng-container>
              @if (employmentConditionConfirmationStatusVisible()) {
                <ng-container matColumnDef="EmploymentConditionsConfirmationStatusId">
                  <mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [matTooltip]="'WL-EmploymentConditionsConfirmationStatus' | translate"
                    matTooltipPosition="above"
                    matTooltipClass="worker-agreements-list-tooltip"
                    class="hidden-sort"
                    >
                    {{ 'WL-EmploymentConditionsConfirmationStatusShort' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    @if (!!element.EmploymentConditionsConfirmationStatusId) {
                      <div>
                        @if (
                          element.EmploymentConditionsConfirmationStatusId === employmentConditionsConfirmationStatusEnum.PendingGeneration) {
                          <div
                            >
                            <mat-icon
                              [matTooltip]="getEmploymentConditionsConfirmationStatusEnum(element.EmploymentConditionsConfirmationStatusId) | translate"
                              matTooltipClass="worker-agreements-list-tooltip"
                              >update</mat-icon
                              >
                            </div>
                          } @else {
                            @if (element.EmploymentConditionsConfirmationStatusId !== employmentConditionsConfirmationStatusEnum.NoConfirmation) {
                              <mat-icon
                                class="employment-conditions-confirmation-status"
                                [inline]="true"
                                [matTooltip]="getEmploymentConditionsConfirmationStatusEnum(element.EmploymentConditionsConfirmationStatusId) | translate"
                                [matTooltipClass]="getEmploymentConditionsConfirmationTooltipClass(element.EmploymentConditionsConfirmationStatusId)"
                                [svgIcon]="'employment-conditions-confirmation-status-icon'"
                                [class.fill--pink]="element.EmploymentConditionsConfirmationStatusId === employmentConditionsConfirmationStatusEnum.Generated"
                                [class.fill--blue]="element.EmploymentConditionsConfirmationStatusId === employmentConditionsConfirmationStatusEnum.Signed"
                                [class.fill--darkgreen]="element.EmploymentConditionsConfirmationStatusId === employmentConditionsConfirmationStatusEnum.Read"
                                >
                              </mat-icon>
                            }
                          }
                        </div>
                      }
                    </mat-cell>
                  </ng-container>
                }
                <ng-container matColumnDef="AgreementStartDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'WL-AgreementStartDate' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.AgreementStartDate | date : 'yyyy-MM-dd' }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="AgreementEndEffectiveDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'WL-AgreementEndDate' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.AgreementEndEffectiveDate | date : 'yyyy-MM-dd' }}
                    @if (element.AgreementTerminationEndDate) {
                      <mat-icon
                        class="material-icons-outlined"
                        [matTooltip]="createAgreementEndDateTooltipText(element)"
                        matTooltipClass="worker-agreements-list-tooltip"
                        >info</mat-icon
                        >
                      }
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="AgreementConclusionDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                      {{ 'AgreementConclusionDate' | translate }}
                      <app-table-header-sort></app-table-header-sort>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">{{ element.AgreementConclusionDate | date : 'yyyy-MM-dd' }}</mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="WorkerStatus">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                      {{ 'WL-WorkerStatus' | translate }} <app-table-header-sort></app-table-header-sort>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div
                        class="label"
                        [class.label--green]="element.WorkerStatusId === workerStatusEnum.Activated"
                        [class.label--orange]="element.WorkerStatusId === workerStatusEnum.ActivationInProgress"
                        [class.label--yellow]="element.WorkerStatusId === workerStatusEnum.Created"
                        >
                        <span class="label__dot"></span>
                        <span class="label__name">{{ element.WorkerStatus }}</span>
                      </div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="WorkerFormStatus">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                      {{ 'WL-WorkerFormStatus' | translate }}
                      <app-table-header-sort></app-table-header-sort>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <div
                        class="label"
                        [class.label--green]="element.WorkerFormStatusId === workerFormStatusEnum.Approved"
                        [class.label--orange]="element.WorkerFormStatusId === workerFormStatusEnum.Draft"
                        >
                        <span class="label__dot"></span>
                        <span class="label__name">{{ element.WorkerFormStatus }}</span>
                      </div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="AgreementStatus" [stickyEnd]="screenService.isAboveMd$ | async">
                    <mat-header-cell
                      *matHeaderCellDef
                      [style.minWidth.px]="getColumnWidth('AgreementStatus')"
                      [style.maxWidth.px]="getColumnWidth('AgreementStatus')"
                      >
                      {{ 'WL-AgreementStatus' | translate }}
                    </mat-header-cell>
                    <mat-cell
                      *matCellDef="let element"
                      [style.minWidth.px]="getColumnWidth('AgreementStatus')"
                      [style.maxWidth.px]="getColumnWidth('AgreementStatus')"
                      [matTooltip]="element.AgreementStatus"
                      matTooltipClass="worker-agreements-list-tooltip"
                      >
                      <div
                        class="label"
                  [class.label--green]="
                    element.AgreementStatusId === workerAgreementStatusEnum.Accepted || element.AgreementStatusId === workerAgreementStatusEnum.Active
                  "
                        [class.label--yellow]="element.AgreementStatusId === workerAgreementStatusEnum.PendingApproval"
                        [class.label--orange]="element.AgreementStatusId === workerAgreementStatusEnum.WaitingForGeneration"
                        [class.label--blue]="element.AgreementStatusId === workerAgreementStatusEnum.Annex"
                        >
                        <span class="label__dot"></span>
                        <span class="label__name">{{ element.AgreementStatus }}</span>
                      </div>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="Actions" stickyEnd>
                    <mat-header-cell *matHeaderCellDef>{{ 'WAD-Actions' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      <ng-container>
                        @if (hasAnyAction(element)) {
                          <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                            <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                          </button>
                        }
                      </ng-container>

                      <mat-menu #menuRow="matMenu" panelClass="actions-menu">
                        @if (isDetailsButtonVisible(element.AgreementStatusId)) {
                          <ng-container *ngTemplateOutlet="detailsButton"></ng-container>
                          <ng-template #detailsButton>
                            <button
                        [routerLink]="[
                          '/workers',
                          element.WorkerId,
                          'employmentType',
                          element.EmploymentTypeId,
                          'agreements',
                          element.AgreementId,
                          'details'
                        ]"
                              mat-button
                              >
                              <mat-icon class="material-icons-outlined">visibility</mat-icon>
                              <span class="button-text">{{ 'WL-WorkerAgreementDetails' | translate }}</span>
                            </button>
                          </ng-template>
                        }

                        @if (isAgreementFileButtonVisible(element)) {
                          <button
                      *ifHasPermissionsOnWorkerProfile="
                        ['AgreementPreview', 'AgreementPreviewAllExternalWorkers', 'AgreementPreviewMyExternalWorkers'];
                        authServerUserId: element.AuthServerUserId
                      "
                            mat-button
                            (click)="onShowAgreementClick(element.AgreementId, element.FirstName, element.LastName)"
                            >
                            <mat-icon class="material-icons-outlined">find_in_page</mat-icon>
                            <span class="button-text">{{ 'WL-ShowAgreementButton' | translate }}</span>
                          </button>
                          <button
                      *ifHasPermissionsOnWorkerProfile="
                        ['AgreementPreview', 'AgreementPreviewAllExternalWorkers', 'AgreementPreviewMyExternalWorkers'];
                        authServerUserId: element.AuthServerUserId
                      "
                            mat-button
                            (click)="onDownloadAgreementClick(element.AgreementId, element.FirstName, element.LastName)"
                            >
                            <mat-icon class="material-icons-outlined">file_download</mat-icon>
                            <span class="button-text">{{ 'WL-DownloadAgreementButton' | translate }}</span>
                          </button>
                        }

                        <mat-divider class="custom-divider"></mat-divider>

                        @if (isExtendAgreementButtonVisible(element.AgreementStatusId, element.AgreementTypeId, element.EmploymentTypeId)) {
                          <button
                            *ifHasPermissions="['ManageAllExternalWorkersList', 'ManageMyExternalWorkersList']"
                            mat-button
                            (click)="onExtendAgreementClick(element.AgreementId, element.WorkerId, element.EmploymentTypeId)"
                            >
                            <mat-icon class="material-icons-outlined">published_with_changes</mat-icon>
                            <span class="button-text">{{ 'ExtendAgreement' | translate }}</span>
                          </button>
                        }

                        @if (isReplaceAgreementButtonVisible(element.AgreementStatusId, element.EmploymentTypeId)) {
                          <button *ifHasPermissions="['ReplaceAgreement']" mat-button (click)="replaceAgreement(element)">
                            <mat-icon class="material-icons-outlined">swap_horiz</mat-icon>
                            <span class="button-text">{{ 'ReplaceWorkerAgreement' | translate }}</span>
                          </button>
                        }

                        @if (isEditAgreementButtonVisible(element.AgreementStatusId)) {
                          <button mat-button (click)="onEditAgreementClick(element)">
                            <mat-icon class="material-icons-outlined">create</mat-icon>
                            <span class="button-text">{{ 'WL-EditWorkerAgreement' | translate }}</span>
                          </button>
                        }

                        @if (isAgreementFileButtonVisible(element)) {
                          @if (isTerminateButtonVisible(element)) {
                            <button
                              mat-button
                        (click)="
                          onTerminateClick(
                            element.WorkerId,
                            element.FirstName + ' ' + element.LastName,
                            element.EmployerName,
                            element.AgreementId,
                            element.NoticePeriodId,
                            element.AgreementStartDate,
                            element.AgreementEndDate,
                            element.EmploymentTypeId,
                            element.HasAgreementTerminationReason
                          )
                        "
                              >
                              <mat-icon>highlight_off</mat-icon>
                              <span class="button-text">{{ 'TerminateAgreement' | translate }}</span>
                            </button>
                          }
                        }
                      </mat-menu>
                    </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="progress">
                    <mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                      <mat-progress-bar
                        [mode]="dataSource.isLoading ? 'indeterminate' : 'determinate'"
                        class="table-progress"
                        [class.show]=""
                        color="accent"
                        >
                      </mat-progress-bar>
                    </mat-header-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: sticky" [style.top.px]="offset$ | async"></mat-header-row>
                  <mat-header-row *matHeaderRowDef="['progress']; sticky: sticky" class="progress" [style.top.px]="(offset$ | async) + 56">
                  </mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <app-item-counter class="item-counter" [position]="scrollItemPosition" [length]="dataSource.absoluteDataLength"></app-item-counter>
        </div>
      </div>
